export function getdata(){
	var obj = {
		
			headData:[
				{
					title: "项目及栏次",
					prop: "title",
					width:"150px",
					custom:true,
				},
				{
					title: "栏次",
					prop: "grade",
					width:"56px",
					custom:true
				},
				{
					title:"本期服务、不动产和无形资产价税合计额（免税销售额）",
					prop: "zzs_3_x_1",
					width:"116px",
					custom:true,
					children:[
						{
						title: "1",
						prop: "",
						children:[
							{
							title: "1",
							prop: "zzs_3_x_1",
							custom:true,
							},
						]
						}
					]
				},
				{ 
					title: "服务、不动产和无形资产扣除项目",
					prop: "",
					children:[
						{
						title: "期初余额",
						prop: "",
						children:[
							{
							title: "2",
							prop: "zzs_3_x_2",
							custom:true,
							},
						]
						},
						{
						title: "本期发生额",
						prop: "",
						children:[
							{
							title: "3",
							prop: "zzs_3_x_3",
							custom:true,
							},
						]
						},
						{
						title: "本期应扣除金额",
						prop: "",
						children:[
							{
							title: "4=2+3",
							prop: "zzs_3_x_4",
							custom:true,
							},
						]
						},
						{
						title: "本期实际扣除金额",
						prop: "",
						children:[
							{
							title: "5(5≤1且5≤4)",
							prop: "zzs_3_x_5",
							custom:true,
							},
						]
						},
						{
						title: "期末余额",
						prop: "",
						children:[
							{
							title: "6=4-5",
							prop: "zzs_3_x_6",
							custom:true,
							},
						]
						}
					]
				},
				
			],
			tableData:[
				{
					title:'13%税率的项目',
					grade:"1",
					disabledzzs_3_x_1:true,
					disabledzzs_3_x_2:true,
					disabledzzs_3_x_4:true,
					disabledzzs_3_x_6:true
				},
				{
					title:'9%税率的项目',
					grade:"2",
					disabledzzs_3_x_1:true,
					disabledzzs_3_x_2:true,
					disabledzzs_3_x_4:true,
					disabledzzs_3_x_6:true
				},
				{
					title:'6%税率的项目(不含金融商品转让)',
					grade:"3",
					disabledzzs_3_x_2:true,
					disabledzzs_3_x_4:true,
					disabledzzs_3_x_6:true
				},
				{
					title:'6%税率的金融商品转让项目',
					grade:"4",
					disabledzzs_3_x_2:true,
					disabledzzs_3_x_4:true,
					disabledzzs_3_x_6:true
				},
				{
					title:'5%征收率的项目',
					grade:"5",
					disabledzzs_3_x_1:true,
					disabledzzs_3_x_2:true,
					disabledzzs_3_x_4:true,
					disabledzzs_3_x_6:true
				},
				{
					title:'3%征收率的项目',
					grade:"6",
					disabledzzs_3_x_1:true,
					disabledzzs_3_x_2:true,
					disabledzzs_3_x_4:true,
					disabledzzs_3_x_6:true
				},
				{
					title:'免抵退税的项目',
					grade:"7",
					disabledzzs_3_x_1:true,
					disabledzzs_3_x_2:true,
					disabledzzs_3_x_4:true,
					disabledzzs_3_x_6:true
				},
				{
					title:'免税的项目',
					grade:"8",
					disabledzzs_3_x_1:true,
					disabledzzs_3_x_2:true,
					disabledzzs_3_x_4:true,
					disabledzzs_3_x_6:true
				},
			]
		
	}
	return obj
}
